import ReactDOM from "react-dom/client";
import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { App } from "src/app";
import AppLayout from "src/layouts/AppLayout";
import Loader from "src/pages/components/loader";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense fallback={<Loader message="" />}>
        <AppLayout>
          <App />
        </AppLayout>
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
